import axios from 'axios';
import { api } from "../utils/config";

// Registrar um usuário
const register = async (data) => {
  try {
    const res = await axios.post(`${api}/users/register`, data, {
      withCredentials: true, // Habilita o envio de cookies assinados
    });

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    console.error("Erro ao registrar:", error);
    throw error;
  }
};

// Logout do usuário
const logout = async (data) => {
  try {
    const res = await axios.post(`${api}/users/logout`, {}, { withCredentials: true })
    .then((res) => res)
    .catch((err) => err);

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }
  } catch (error) {
    console.error("Erro ao realizar logout:", error);
  }
};

// Fazer login de um usuário
const login = async (data) => {
  try {
    const res = await axios.post(`${api}/users/login`, data, {
      withCredentials: true, // Habilita cookies assinados para autenticação
    }).then((res) => res)
      .catch((err) => err);

      if(res.data){
        return res.data
      }else{
        return res.response.data;
      }
    
  } catch (error) {
    console.error("Erro ao fazer login:", error);
    throw error;
  }
};

const getProfile = async (token) => {
  try {
    const res = await axios.get(`${api}/users/profile`, {
      withCredentials: true,  // Permite o envio de cookies assinados
    });

    return res.data;
    
  } catch (error) {
    console.error("Erro ao obter perfil:", error);
    throw error;
  }
};


const authService = {
  register,
  logout,
  login,
  getProfile,
};

export default authService;